import React from 'react';
import ReservationTimeView from './views/ReservationTimeView';
import { useReservationTime } from './hooks/ReservationTime.hook';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';

const ReservationTimeController = () => {
  const { idSubSpace } = useParams();
  const { loading, error, handleSubmit, goToDatePicker } = useReservationTime(idSubSpace);
  const languageData = useSelector(state => state.lenguage?.lang);
  const initialValues = {
    email: '',
    password: '',
    confirmPassword: '',
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Required'),
    password: Yup.string().min(6, 'Minimum 6 characters').required('Required'),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password'), null], 'Passwords must match')
      .required('Required'),
  });

  const onReservationTime = async values => {
    console.log('Simulated Reservation Time with values:', values);
  };

  return (
    <ReservationTimeView
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={values => handleSubmit(values, onReservationTime)}
      loading={loading}
      error={error}
      languageData={languageData}
      goToDatePicker={goToDatePicker}
      idSubSpace={idSubSpace}
    />
  );
};

export default ReservationTimeController;
